import React, { useEffect, useRef } from "react";
import "../style/Question.scss";

const Question = (props) => {
  const { question, answer, img, type } = props;
  const imgRef = useRef(null);

  const deg = Math.floor((Math.random() - 0.5) * 5);
  const t_x = Math.floor((Math.random() - 0.5) * 20);

  // useEffect(() => {
  //   if (imgRef.current) {
  //     imgRef.current.style.transform = `translateX(${t_x}px) rotate(${deg}deg)`;
  //   }
  // }, [imgRef.current]);

  return (
    <div
      className="question-answer-block"
      style={{ marginTop: type === "first" ? "20px" : "" }}
    >
      {/* <div className="img-block">
        <img
          ref={imgRef}
          className="answer-img"
          src={`${process.env.PUBLIC_URL + "/" + img}`}
        />
      </div> */}

      <div className="question-block">
        <div
          className="question"
          dangerouslySetInnerHTML={{ __html: question }}
        ></div>
        {/* <div className="question"> {question} </div> */}
      </div>

      <div className="answer-block">
        <div className="answer"> {answer} </div>
      </div>
    </div>
  );
};

export default Question;
